import { rootUrl } from '@/constants';
import { getCookies } from '@/utils/cookie';
import axios from 'axios';

export const deleteProfile = async () => {
  return await axios.delete(`${rootUrl}/psychologist/delete/profile`, {
    withCredentials: true,
    params: {
      token: getCookies('auth'),
    },
  });
};
